import React from 'react'
import "../style/Footer.css"

const Footer = () => {
  return (
    <div className='footer'>     
        <p>Copyright © 2023 Graphic Era Hill University All Rights Reserved</p>
        
       </div>

   
  )
}

export default Footer
